import { Component, OnInit, inject } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { ExternalIdType } from 'src/app/services/cases/cases.service';
import {
  EditCaseDialogService,
  ExternalIdControls,
} from '../edit-case-dialog.service';
import { PayeeFormFieldComponent } from '../../../shared/payee-form-fields/payee-form-field/payee-form-field.component';
import { PayeeInputDirective } from '../../../shared/payee-input/payee-input.directive';
import { PayeeIconButtonComponent } from '../../../shared/payee-buttons/payee-icon-button/payee-icon-button.component';
import { PayeeIconComponent } from '../../../shared/payee-icon/payee-icon.component';

@Component({
  selector: 'app-external-ids-form',
  templateUrl: './external-ids-form.component.html',
  styleUrls: ['./external-ids-form.component.scss'],
  imports: [
    PayeeFormFieldComponent,
    PayeeInputDirective,
    FormsModule,
    ReactiveFormsModule,
    PayeeIconButtonComponent,
    PayeeIconComponent,
  ],
})
export class ExternalIdsFormComponent implements OnInit {
  private editCaseDialogService = inject(EditCaseDialogService);
  private fb = inject(FormBuilder);

  get form() {
    return this.editCaseDialogService.form.controls.legal_relationship.controls
      .external_ids;
  }

  ngOnInit(): void {
    this.syncExternalIdControls();
  }

  externalIdTypeDisplayWith(option?: ExternalIdType): string {
    if (!option) {
      return '';
    }

    return option === 'ofp'
      ? 'Fizetési meghagyásos eljárás ügyszáma'
      : option === 'enforcement'
        ? 'Végrehajtás ügyszám'
        : 'Végrehajtói jelvényszám';
  }

  clearExternalId(
    event: Event,
    externalId: FormGroup<ExternalIdControls>,
  ): void {
    event.preventDefault();
    event.stopPropagation();
    externalId.controls.value.setValue('');
  }

  private allowedExternalIdTypes(): ExternalIdType[] {
    const productType =
      this.editCaseDialogService.data?.payee_case.product_type;

    if (productType === 'hard_1') {
      return ['ofp'];
    }

    if (productType === 'hard_2') {
      return ['enforcement', 'bailiff'];
    }

    return [];
  }

  private syncExternalIdControls(): void {
    const allowed = this.allowedExternalIdTypes();
    const existing = this.form.getRawValue();
    const types = [
      ...allowed,
      ...existing
        .map((externalId) => externalId.type)
        .filter((type) => !allowed.includes(type)),
    ];

    this.form.clear();
    for (const type of types) {
      this.form.push(
        this.fb.group<ExternalIdControls>({
          type: this.fb.control(type, { nonNullable: true }),
          value: this.fb.control(
            existing.find((externalId) => externalId.type === type)?.value ??
              '',
            { nonNullable: true },
          ),
        }),
      );
    }
  }
}
